document.addEventListener('DOMContentLoaded', function() {
  // Function to handle the swiper controls repositioning
  function setupMobileSwiperControls() {
    // Target only testimonials_ghGxwj section
    const testimonialSection = document.querySelector('[id*="testimonials_ghGxwj"]');
    if (!testimonialSection) return;
    
    // Get original swiper controls
    const originalControls = testimonialSection.querySelector('.section__header .swiper-controls');
    if (!originalControls) return;
    
    // Get the section content container
    const sectionContent = testimonialSection.querySelector('.section__content');
    if (!sectionContent) return;
    
    // Check if mobile controls already exist
    if (testimonialSection.querySelector('.mobile-swiper-controls')) return;
    
    // Clone the swiper controls
    const mobileControls = originalControls.cloneNode(true);
    mobileControls.classList.add('mobile-swiper-controls');
    
    // Insert after section content
    sectionContent.parentNode.insertBefore(mobileControls, sectionContent.nextSibling);
    
    // Copy event listeners from original buttons to cloned buttons
    const originalPrevBtn = originalControls.querySelector('.swiper-btn-prev');
    const originalNextBtn = originalControls.querySelector('.swiper-btn-next');
    const clonedPrevBtn = mobileControls.querySelector('.swiper-btn-prev');
    const clonedNextBtn = mobileControls.querySelector('.swiper-btn-next');
    
    if (originalPrevBtn && clonedPrevBtn) {
      clonedPrevBtn.addEventListener('click', function() {
        originalPrevBtn.click();
      });
    }
    
    if (originalNextBtn && clonedNextBtn) {
      clonedNextBtn.addEventListener('click', function() {
        originalNextBtn.click();
      });
    }
  }
  
  // Run on page load
  setupMobileSwiperControls();
  
  // Also run on Shopify section reload events
  document.addEventListener('shopify:section:load', setupMobileSwiperControls);
});
